module.exports = __webpack_public_path__ + "static/img/1.00dd6ece.png";